import { AnyReduxState } from '../state.types';

export type WidgetReduxState = AnyReduxState & {
  widgetId: string;
}

export const initialState = (): WidgetReduxState => ({
  widgetId: '',
});
